import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `elplan_bids` anchor component.
 * Keep in sync with ElplanBidsProps in src/ui/uiConfig/anchorComponents/ElplanBids/ElplanBids.types.ts
 */
export const elplanBidsPropDocs: ComponentDocMap = {
  items: {
    description: 'Bid value definitions displayed in the component.',
    type: 'ElplanBidsItem[]',
    example: '[{ title: "__Bid price", data_id: "bid_price" }]',
  },
}
